/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_Connection_ErrorInputs */

const cs_settings_calendar_connection_error = /** @type {(inputs: Settings_Calendar_Connection_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připojení kalendáře selhalo. Zkuste to znovu, nebo požádejte správce.`)
};

const en_settings_calendar_connection_error = /** @type {(inputs: Settings_Calendar_Connection_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar connection failed. Try again, or ask an admin.`)
};

/**
* | output |
* | --- |
* | "Calendar connection failed. Try again, or ask an admin." |
*
* @param {Settings_Calendar_Connection_ErrorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_connection_error = /** @type {((inputs?: Settings_Calendar_Connection_ErrorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_Connection_ErrorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_connection_error(inputs)
	return cs_settings_calendar_connection_error(inputs)
});